const required = ["VITE_API_URL", "VITE_MAPBOX_STYLE", "VITE_MAPBOX_API_KEY"] as const;

const missing = required.filter((key) => !import.meta.env[key]);

if (missing.length > 0) {
  throw new Error(`Missing required environment variables: ${missing.join(", ")}`);
}

export const env = {
  VITE_API_URL: import.meta.env.VITE_API_URL as string,
  VITE_MAPBOX_STYLE: import.meta.env.VITE_MAPBOX_STYLE as string,
  VITE_MAPBOX_API_KEY: import.meta.env.VITE_MAPBOX_API_KEY as string,
};
